import { useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FullScreenLoader } from "@/components/layout/Guards";
import { NeutralLogo } from "@/pages/Login";

const INPUT = "h-11 w-full rounded-control border border-zinc-300 px-3 text-sm outline-none focus:border-zinc-900";

export default function DemoLogin() {
  const { status } = useAuth();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  if (status === "loading") return <FullScreenLoader />;
  if (status === "authed") return <Navigate to="/dashboard" replace />;
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr(null);
    try { await api.post("/auth/demo-login", f); window.location.href = "/dashboard"; }
    catch (x) { const d = x.response?.data?.detail; setErr(typeof d === "string" ? d : "Accesso non riuscito."); setBusy(false); }
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0f1012] bg-cover bg-center p-6" style={{ backgroundImage: "url(/brand/login-neutral.jpg)" }} data-testid="demo-login-page">
      <form onSubmit={submit} className="w-full max-w-sm animate-rise space-y-3 rounded-xl bg-white p-8 shadow-2xl" data-testid="login-demo-form">
        <NeutralLogo className="mb-6" />
        <h1 className="font-display text-2xl font-bold tracking-tight text-zinc-900">Prova la demo</h1>
        <p className="pb-2 text-sm text-zinc-500">Utenza dimostrativa con dati di esempio.</p>
        <input type="email" required placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={INPUT} data-testid="login-demo-email" />
        <input type="password" required placeholder="Password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className={INPUT} data-testid="login-demo-password" />
        {err && <p className="text-xs text-red-600" data-testid="login-demo-error">{err}</p>}
        <button type="submit" disabled={busy} className="h-11 w-full rounded-control bg-zinc-900 text-sm font-semibold text-white hover:bg-zinc-700 disabled:opacity-50" data-testid="login-demo-submit">{busy ? "Accesso…" : "Entra nella demo"}</button>
      </form>
    </div>
  );
}
